import { useEffect } from "react";

import {
  Button,
  Stack,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { usePostHog } from "posthog-js/react";
import { Link as RouterLink } from "react-router-dom";

import { NAV_ROUTES } from "components/NavigationBar";
import { ClientAppEvent } from "constants/index";
import { useRoleContext } from "hooks";

import { BANNER_CTA_BUTTON_SX, BANNER_TEXT_MIN_WIDTH } from "../../constants";

export function FillCarrierProfileBanner() {
  const showText = useMediaQuery(BANNER_TEXT_MIN_WIDTH);
  const { company } = useRoleContext();
  const posthog = usePostHog();
  const companyId = company?.id ?? null;

  useEffect(() => {
    if (companyId != null) {
      posthog?.capture(ClientAppEvent.CARRIER_PROFILE_BANNER_VIEWED);
    }
  }, [posthog, companyId]);

  if (companyId == null) {
    return null;
  }

  return (
    <Stack direction="row" alignItems="center" gap={2}>
      {showText && (
        <Typography variant="h6" color="white">
          Update your carrier profile so shippers can find you.
        </Typography>
      )}
      <Tooltip title="Fill out your carrier profile to help shippers find and trust your company.">
        <Button
          component={RouterLink}
          to={NAV_ROUTES.companyProfile(companyId)}
          variant="contained"
          onClick={() =>
            posthog?.capture(ClientAppEvent.CARRIER_PROFILE_BANNER_CLICKED)
          }
          sx={BANNER_CTA_BUTTON_SX}
        >
          Update Profile
        </Button>
      </Tooltip>
    </Stack>
  );
}
